import { Box, Spinner } from '@apia/theme';
import { formatMessage } from '../../../../utils/util';
import IconButton from '../../buttons/IconButton';

const SearchLabel = ({
  isLoading: isSearching,
  onDelete,
  searchString,
}: {
  isLoading: boolean;
  onDelete?: () => unknown;
  searchString: string;
}) => {
  if (!searchString && !isSearching) return null;
  return (
    <Box className={`tree__searchLabelBox ${isSearching ? 'isLoading' : ''}`}>
      {isSearching ? (
        <Spinner className="tree__loading" size={20} />
      ) : (
        <Box as="label" className="tree__searchLabel">
          {formatMessage(window.LBL_FILTERING_BY, { TOK1: searchString })}
          <IconButton
            icon="Close"
            aria-label={window.LBL_DELETE_FILTER}
            onClick={onDelete}
            title={window.LBL_DELETE_FILTER}
            size="iconSm"
            {...window.getVariant('icon-inherit')}
          />
        </Box>
      )}
    </Box>
  );
};

export default SearchLabel;
